export default {
	setData(state, payload) {
		state.SupOnlyDownList = payload;
	},
	setTotalPage(state, payload) {
		state.Total = payload;
	},
	setIsLoading(state, payload) {
		state.IsLoading = payload;
	},
	
	// Thêm items vào đầu mảng
	prependItems(state, payload) {
		if (Array.isArray(payload)) {
			state.SupOnlyDownList = [...payload, ...state.SupOnlyDownList];
			state.Total = state.Total + payload.length;
		}
	},
	
	// Xóa item khỏi mảng theo Id
	removeItemById(state, itemId) {
		state.SupOnlyDownList = state.SupOnlyDownList.filter(item => item.Id !== itemId);
		state.Total = state.Total - 1;
	}
};
